import http from './httpService';

export function getPostalCodes(countryId, stateId, cityId) {
	return http.get(
		`PostalCode?countryId=${countryId}&stateId=${stateId}&municipalityId=${cityId}`
	);
}
